import { CustomNextPage } from '../lib/types';
import { bootstrap } from '../lib/bootstrap';
import { useRouter } from 'next/router';
import axios from 'axios';
import getConfig from 'next/config';
import { useState, useEffect } from 'react';
import {
  useIntercom,
  CustomConfig,
  InitialIntercomScreen
} from './../lib/intercom';
import { Alert, Box, Text } from '../components';
import styled, { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';

const AlertWrapper = styled(Box)`
  position: relative;
  height: 100vh;
`;

const StyledAlert = styled(Alert)`
  ${({ theme }) => css`
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    animation: none;
    -webkit-animation: none;
    @media screen and (max-width: ${theme.breakpoints[2]}) {
      width: 80%;
    }
  `}
`;

const LoadingWrapper = styled(Box)`
  margin-top: 50vh;
  margin-left: 50vw;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const IntercomMessengerPage: CustomNextPage<{}> = () => {
  interface IntercomPayload {
    iss: string;
    iat: number;
    exp: number;
    aud: string;
    attr: {
      ruter_user_id: string;
      trip_id: string;
    };
  }

  const {
    publicRuntimeConfig: { RUTER_INTEGRATION_ENDPOINT }
  } = getConfig();

  const router = useRouter();
  const [data, setData] = useState<CustomConfig>({});
  const [error, setError] = useState('');
  const token = router.query.token;

  useEffect(() => {
    (async () => {
      if (!window.Intercom) return;

      try {
        const { data } = await axios.post<IntercomPayload>(
          `${RUTER_INTEGRATION_ENDPOINT}`,
          {
            token
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
        if (
          (Object.prototype.hasOwnProperty.call(data.attr, 'ruter_user_id') ||
            Object.prototype.hasOwnProperty.call(data.attr, 'maas_user_id')) &&
          Object.prototype.hasOwnProperty.call(data.attr, 'trip_id')
        ) {
          setTimeout(() => {
            setData(data.attr);
          }, 100);
          window.Intercom('onHide', () => {
            window.dispatchEvent(new Event('onIntercomChatClose'));
            window.dispatchEvent(new Event('onChatClose'));
          });
        } else {
          setError('Invalid token');
          window.Intercom('onHide', () => null);
          window.dispatchEvent(
            new CustomEvent('onChatError', {
              detail: {
                message: 'Invalid token'
              }
            })
          );
          window.Intercom('hide');
        }
      } catch (error) {
        setError(error.message);
        window.Intercom('onHide', () => null);
        window.dispatchEvent(
          new CustomEvent('onChatError', {
            detail: {
              message: error.message,
              error
            }
          })
        );
        window.Intercom('hide');
      }
    })();
  }, []);

  useEffect(() => {
    if (!data) return;

    setTimeout(() => {
      if (data?.initial_screen) {
        switch (data.initial_screen) {
          case InitialIntercomScreen.HOME:
          case InitialIntercomScreen.HELP:
            window.Intercom?.('show');
            break;
          case InitialIntercomScreen.NEW_MESSAGE:
            window.Intercom?.('showNewMessage');
            break;
          case InitialIntercomScreen.MESSAGE_LIST:
            window.Intercom?.('showMessages');
            break;
          default:
            window.dispatchEvent(
              new CustomEvent('onChatError', {
                detail: { message: 'Invalid initial screen' }
              })
            );
            break;
        }
      } else {
        window.Intercom?.('showNewMessage');
      }

      window.dispatchEvent(new Event('onChatLoaded'));
    }, 50);
  }, [data]);

  useIntercom(false, data);

  if (error) {
    return (
      <AlertWrapper>
        <StyledAlert variant="error">{error}</StyledAlert>
      </AlertWrapper>
    );
  }

  if (!data) {
    return (
      <LoadingWrapper>
        <Text>
          {' '}
          <FormattedMessage
            id="pages.intercom-app"
            defaultMessage="Loading chat..."
          />
        </Text>
      </LoadingWrapper>
    );
  }

  return <div />;
};

export default bootstrap(IntercomMessengerPage);
